<template>
	<div class="wrap" @click.stop="" @touchstart.stop="" @touchmove.stop="">
		<button class="btn btn-default w"
			:class="{active : isActive}"
			:disabled="disabled"
			@click="toggle">
				{{selectedName || placeholder}} <i class="fa fa-caret-down" ></i>
				<!-- <i class="closei fa fa-window-close" v-show="isActive && isClear" @click="clearSel"></i> -->
		</button>
		<div :key="num+'-'+id" class="cont" :style="{maxHeight: (maxHeight || 300) + 'px'}" :class="{active : isActive,pt0:filter || btnShow}" :id="id">
			<ul class="beautyul">
				<li v-if="multiple && soptions.length && isShowSelectAll" class="select-condition">
					<div class="btn-group btn-block btn-con-border mb10" v-if="btnShow">
						<button type="button" class="btn btn-default select-btn max-width-100" @click="selectAll" v-if="showSelectBtn">全选</button>
						<button type="button" class="btn btn-default select-btn max-width-100" @click="cancelAll" v-if="showCancelBtn">取消</button>
					</div>
					<input type="text" class="form-control" placeholder="请输入" v-if="filter" v-model="filterKey" @input="filterHandle">
				</li>
				<li v-for="(o,index) in soptions"
					@click="selHandle(o,index)"
					:class="{
						active:o.$isActive,
						disabled: o.$isDisabled,
						visibility: o.$isVisible,
					}"
					:key="o.name + index">
					<p>{{o[name]}}</p> <i class="fa"></i>
				</li>
				<li v-show="isEmpty" class="text-center">
					暂无数据
				</li>
			</ul>
		</div>
		<!--
		<select>
			<option value="o.value" v-for="o in sconfig.options">{{o.name}}</option>
		</select> -->
	</div>
</template>
<script>
export default {
	name : 'kxSelect',
	props : {
		'options' : {required : true,type : Array},
		'multiple' : {type : Boolean,default : false},
		'filter' : {type : Boolean,default : false},
		'beautyName' : {type : String},
		'name' : {default : 'name',type : String},
		'valueName' : {default : 'value',type : String},
		'change' : {default : Function,type : Function},
		'isClear' : {type : Boolean,default : false},
		value : {},
		maxHeight : {type : Number,default : 300},
		placeholder : String,
		canCancel : {type : Boolean, default : true},
		defaultSelect : Boolean,
		disabled : Boolean,
		maxLimit : Number,
		// 是否 显示 取消 / 全选 / 输入框
		isShowSelectAll : {
			type : Boolean,
			default : true,
		},
		// 取消 / 全选 是否展示
		btnShow: {
			type : Boolean,
			default : true,
		},
		// 全选按钮
		showSelectBtn: {
			type : Boolean,
			default : true,
		},
		// 取消按钮
		showCancelBtn: {
			type : Boolean,
			default : true,
		},

	},
	destroyed (){
		this.$kxSelect.remove(this);
	},
	mounted (){
		this.$kxSelect.add(this);
		this.soptions = this.Helper.clone(this.options,true);
		this.defaultSelectDo();
	},
	data (){
		return {
			isActive : false,
			soptions : [],
			id : 'kxSelect_beauty_ul_'+this._uid,
			filterKey: '',
			num:1
		}
	},
	methods : {
		close (){
			this.isActive = false;
			this.num += 1;
		},
		closeSelect(e) {
			e && e.preventDefault();
			this.isActive = false;
		},
		toggle(e) {
			e && e.preventDefault();
			this.isActive = !this.isActive;
			if (this.isActive) {
				this.filterKey = ''
				this.$nextTick(() => {
					this.selectDomPosition()
					this.defaultSelectDo()
				})
			} else {
				this.num += 1;
			}
		},
		selectDomPosition() {
			let selectDom = document.getElementById(this.id);
			if (selectDom) {
				let {left} = this.Helper.getOffset(selectDom);
				let leftMain = document.getElementById('leftMain');
				if(left + selectDom.offsetWidth > leftMain.offsetWidth){
					selectDom.classList.add('right');
				}else{
					selectDom.classList.remove('right');
				}
			}
		},
		selHandle (option,index){
			if(this.maxLimit > 0 && this.value.length >= this.maxLimit && !option.$isActive){
				if(this.instanceToast) {
					this.instanceToast.close();
				}
				this.instanceToast = this.$toast(`最多可选${this.maxLimit}项`);
				return;
			}
			if(option.$isDisabled){
				return;
			}
			this.setActive([index]);
			this.$emit('change')
			requestAnimationFrame(() => {
				this.selectDomPosition()
			})
		},
		filterHandle() {
			this.soptions.map( item => {
				this.$set(item, '$isVisible', true)
				if(item.name.toString().includes(this.filterKey)) {
					this.$set(item, '$isVisible', false)
				}
			})
		},
		setActive (sindexArr,notNeedChange=false){
			if(this.multiple){
				for(let index of sindexArr.keys()){
					let i = sindexArr[index];
					this.$set(this.soptions[i],"$isActive",!this.soptions[i].$isActive);
					if(!this.soptions[i].$isActive){
						this.$emit('removeTag');
					}
				}
			}else{
				for(let [i,v] of this.soptions.entries()){
					// let isactive = sindexArr.includes(index) &&
					// 				this.soptions[sindexArr[0]][this.valueName] !== undefined;
					// console.log(isactive);
					// this.$set(v,"$isActive",!isactive);
					// console.log(i,v)
					if(i === sindexArr[0] && sindexArr.includes(i) &&
									this.soptions[sindexArr[0]][this.valueName] !== undefined){
						this.$set(v,"$isActive", this.canCancel ? !v.$isActive : true);
					}else{
						this.$set(v,"$isActive",false);
					}

				}
				this.toggle();
			}
			if(!notNeedChange){
				this.$emit('input',this.soptions.filter(v=>v.$isActive));
			}
		},
		selectAll() {
			for (let [, v] of this.soptions.entries()) {
				if (!v.$isDisabled && !v.$isVisible) {
					this.$set(v,"$isActive",true);
				}
			}
			this.$emit('input',this.soptions.filter(v=>v.$isActive));
			this.$emit('change')
			requestAnimationFrame(() => {
				this.selectDomPosition()
			})
		},
		cancelAll (){
			for(let [,v] of this.soptions.entries()){
				this.$set(v,"$isActive",false);
			}
			this.$emit('input',this.soptions.filter(v=>v.$isActive));
			this.$emit('change')
			requestAnimationFrame(() => {
				this.selectDomPosition()
			})
		},
		clearSel (){
			for(let [,v] of this.soptions.entries()){
				this.$set(v,"$isActive",false);
			}
			this.$emit('input',this.soptions.filter(v=>v.$isActive));
			this.$emit('change')
		},
		defaultSelectDo () {
			if(this.defaultSelect && this.soptions[0]){
				if(!Array.isArray(this.value)) {
					this.$set(this.soptions[0],'$isActive',true);
				} else {
					this.soptions.map((option)=>{
						if(Array.isArray(this.value)){
							this.value.map((v)=>{
								if(v[this.valueName] === option[this.valueName]){
									this.$set(option,'$isActive',true);
								}
							})
						}
					})
				}
				this.$emit('input',this.soptions.filter(v=>v.$isActive));
				this.$emit('defaultSelectChange');
			}
			this.soptions.forEach(ele => {
				this.$set(ele,'$isVisible',false);
			})
		},
	},
	watch : {
		isActive (newval){
			if(newval){
				this.$kxSelect.closeOthers(this);
			}
		},
		options : {
			immediate : true,
			handler (){
				this.soptions = this.Helper.clone(this.options,true);
				this.defaultSelectDo();
			}
		},
		selected (){
			// this.$emit('change')
		},
		value : {
			immediate : true,
			handler(){
				this.soptions.map((option)=>{
					this.$set(option,'$isActive',false);
					if(Array.isArray(this.value)){
						this.value.map((v)=>{
							if(v[this.valueName] === option[this.valueName]){
								// index.push(i);
								this.$set(option,'$isActive',true);
							}
						})
					}else{
						try{
							if(this.value[this.valueName] === option[this.valueName]){
								// index.push(i)
								this.$set(option,'$isActive',true);
							}
						}catch(e){

						}
					}
				})
				// this.setActive(index,true);
			}
		}
	},
	computed : {
		selected (){
			if(this.multiple){
				let active = [];
				for(let [,v] of this.soptions.entries()){
					if(v.$isActive){
						active.push(v);
					}
				}
				return active;
			}else{
				let active = null;
				for(let [,v] of this.soptions.entries()){
					if(v.$isActive){
						active = v;
						break;
					}
				}
				// if(!active){
				// 	active = this.soptions[0];
				// }
				return active;
			}
		},
		selectedName (){
			if(Array.isArray(this.selected)){
				let name = [];
				for(let [,s] of this.selected.entries()){
					name.push(s[this.name]);
				}
				return name.join(',') || this.beautyName;
			}else{
				return this.selected ? this.selected[this.name] : this.beautyName;
			}
		},
		isEmpty() {
			let visibleOptios = this.soptions.filter( item => !item.$isVisible);
			return !this.soptions.length || !visibleOptios.length;
		}
	}
}
</script>
<style scoped>
	.wrap{position: relative;padding-right: 5px;}
	.btn{padding: .05rem .23rem .05rem .17rem;max-width: 200px;overflow: hidden;word-break: break-all;white-space: nowrap;text-overflow: ellipsis;position: relative;width: 100%;cursor: pointer;}
	.btn.active{box-shadow: inset 0 3px 5px #e3e3e3;}
	.btn i{width: .2rem;transition: all 200ms;display: inline-block;position: absolute;right: 5px;top: 5px;}
	.btn .closei{position: static;}
	.btn.active i{transform: rotate(180deg)}
	.cont{
		position: absolute;
	    top: 100%;
	    left: 0;
	    z-index: 1000;
	    display: none;
	    float: left;
	    min-width: 108px;
	    padding: 5px;
	    margin: 2px 0 0;
	    font-size: 14px;
	    text-align: left;
	    list-style: none;
	    background-color: #fff;
	    -webkit-background-clip: padding-box;
	    background-clip: padding-box;
	    border: 1px solid #ccc;
	    border: 1px solid rgba(0,0,0,.15);
	    border-radius: 4px;
	    -webkit-box-shadow: 0 6px 12px rgba(0,0,0,.175);
	    box-shadow: 0 6px 12px rgba(0,0,0,.175);
	    max-height: 300px;
			overflow: auto
	}
	.cont.active{display: block;}
	.cont.right{left: auto;right: 0;}
	.beautyul li{line-height: .35rem;height: .35rem;overflow: hidden;cursor: pointer;}
	.select-condition{
		height: auto !important;
		position: sticky;
		top: 0;
		padding-top: 5px;
		background-color: #Fff;
		z-index: 3;
	}
	.cont.pt0{
		padding-top: 0px;
	}
	.beautyul li p{white-space: nowrap;}
	.beautyul li.active{position: relative;padding-right: 20px;}
	.beautyul li.active i:before{content: "\f00c";}
	.beautyul li.active i{position: absolute;right: 0;top: .08rem;}
	.select-btn{padding-left: 0;padding-right: 0;overflow: unset;}
	.disabled{opacity: 0.6;}
	.visibility{display: none;}
	.max-width-100{max-width: 100%!important;}
</style>



// WEBPACK FOOTER //
// kxSelect.vue?24b7e67f